export const safeAreaConfig = {
  name: 'Patio Transben',
  polygon: [
    [-26.64209329963671, -48.70779400994524],
    [-26.64150933043452, -48.70044368780414],
    [-26.63616153391373, -48.69399472595199],
    [-26.62830177859163, -48.70462239240035],
    [-26.63192117667375, -48.71425486979183],
    [-26.63716774646861, -48.71325884867057],
    [-26.63910269401308, -48.71805845373083],
    [-26.64265851216298, -48.71632231593514]
  ],
  style: {
    color: '#f59e0b',
    fillColor: '#fbbf24',
    fillOpacity: 0.18,
    weight: 3
  }
};
